export enum LocalAudiencia {
    MesmoLocal = "1",
    OutroLocal = "2"
}